<template lang="pug">
  .crud
    modal-import(model="categories" :title="$t('front.import_modal', {model: $t('strings.categories')})")
    modal-categories(:newRecord='newRecord', :is-add='isModalAdd')
    modal-images-categories(:form='form', :title="$t('strings.add_images')")
    .container-fluid
      vm-row.heading(vm-w="12")
        vm-col(vm-type="flex" vm-align="center" vm-lg=6 vm-sm=6)
          div
            h2 {{ $t('strings.categories') }}:
            span {{ $t('strings.description', {attribute: $t('strings.categories')}) }}
          div(style="display:none;")
            vm-button(type="default" icon="list")
            vm-button(type="default" icon="grid" color="rgba(var(--gray),1)")
        vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-lg=6 vm-sm=6)
          div
            vm-button(icon="plus" @click="addCategories") {{ $t('strings.add') }}
            vm-tooltip(:text="$t('strings.options')" delay=".5s")
              vm-dropdown(vm-custom-content vm-trigger-click vm-trigger-outside-click)
                vm-button(type="border" icon="more-horizotnal" color="#afbbc6")

                vm-dropdown-menu
                  vm-dropdown-item.d-flex.justify-content-between(@click="printReport")
                    vm-icon(icon="printer-outline")
                    slot &nbsp;{{ $t('strings.print') }}
                  vm-dropdown-item.d-flex.justify-content-between(@click="deleteCategoriesConfirm" :disabled="!enabledDelete")
                    vm-icon(icon="trash-2-outline")
                    slot &nbsp;{{ $t('strings.delete') }}
                  vm-dropdown-item.d-flex.justify-content-between(@click="setModalImportVisible(true)")
                    vm-icon(icon="upload-outline")
                    slot &nbsp;{{ $t('strings.import') }}
                  vm-dropdown-item.d-flex.justify-content-between(@click="imagesCategory(data[indextr], tr)")
                    vm-icon(icon="image-outline")
                    slot &nbsp;{{ $t('strings.add_images') }}
                  //- More options
                      Agrega mas acciones para colecciones de datos
      vm-row(vm-w="12")
        vm-col.card(vm-sm=12)
          vm-table(multiple v-model="selected"  max-height="350px" :data="categories")
            template(slot="header")
              .d-flex.justify-content-between
                vm-input(ref="search" icon="search" size="small" :placeholder="searchPlaceholder" v-model="filters.where.param" @keyup.enter="applyFilter(filters)"  width="300px")
                div
                  vm-order-by(:sort-by-text="$t('strings.order_by')" placeholder="Ninguno" :data="columnsOrderBy" v-model="filters.orderBy" @change="applyFilter(filters)" size="small" width="200px" :serializer="item => $t('categories.'+ item)")
                  vm-tooltip(:text="$t('strings.filters')" delay=".5s")
                    vm-dropdown(ref='dropdown' vm-custom-content vm-trigger-click vm-trigger-outside-click)
                      vm-button(type="default" icon="funnel-outline" size="small")

                      vm-dropdown-menu(class="filters")
                        .heading.d-flex.justify-content-between
                          h4 {{ $t('strings.filters') }}
                          vm-button(type="flat" size="small" @click="clearFilter") {{ $t('strings.clear') }}

                            //- vm-select.filter(:placeholder="$t('strings.title')" multiple autocomplete :label="$t('categories.title')" v-model="filters.whereIn.title")
                              //- vm-select-item(:key="index" :value="item.value" :text="item.text" v-for="(item,index) in categoriesCatalog.title")
                            //- vm-select.filter(url="customers" columns="tradename,etc" :placeholder="$t('strings.title')" multiple autocomplete :label="$t('categories.title')" v-model="filters.whereIn.title" @input-change="autoCompleteFunc")
                              vm-select-item(:key="index" :value="item.id" :text="item.tradename" v-for="(item,index) in categoriesCatalog.customers")
                            //- vm-date-picker.filter(type="daterange" :label="$t('categories.created_at')" :placeholder="$t('strings.select_date')" @on-change="handleChange" :value="filters.betweenDates.created_at")

                            //NOTA: (agregar clase .filter)
                        .filter.d-flex
                          vm-button(@click="applyFilter(filters)") {{ $t('strings.apply') }}
                  vm-tooltip(:text="$t('strings.display_list')" delay=".5s")
                    vm-button(type="default" size="small" icon="list")
                  vm-tooltip(:text="$t('strings.display_grid')" delay=".5s")
                    vm-button(type="default" size="small" icon="grid" color="rgba(var(--gray),1)")
            template(slot="thead")
              vm-th(:key="index" v-if="column !== 'id'" v-for="(column, index) in columns") {{ $t('categories.' + column) }}
            template(slot-scope="{data}")
              vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in data")
                vm-td(:data="data[indextr][column]" :key="index" v-if="column !== 'id'" v-for="(column, index) in columns")
                  slot(v-if="column != 'status' && column != 'total' && column != 'color' && column != 'total_price' && column != 'discount' && column != 'image'") {{data[indextr][column] }}
                  a(v-if="column === 'image' && data[indextr][column]" :href="data[indextr][column]" target="_blank") Descargar
                  slot(v-if="column === 'color'")
                    .color-circle(:style="`background-color: ${data[indextr][column]}`")
                  slot(v-if="column === 'total_price'") ${{data[indextr][column].toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,").toString()}}
                  slot(v-if="column === 'discount'") ${{data[indextr][column].toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,").toString()}}
                  vm-status-indicator(v-if="column == 'status'" :pulse="data[indextr]['status'] !== 'Activo'" :color="colorStatus(data[indextr]['status'])") {{data[indextr]['status']}}
                vm-td
                vm-dropdown(vm-custom-content vm-trigger-click vm-trigger-outside-click)
                  vm-button(type="flat" icon="more-horizotnal" color="#afbbc6")

                  vm-dropdown-menu
                    vm-dropdown-item.d-flex.justify-content-between(@click="editCategories(data[indextr], tr)")
                      vm-icon(icon="edit-2-outline")
                      slot &nbsp;{{ $t('strings.edit') }}
                    vm-dropdown-item.d-flex.justify-content-between(@click="deleteCategoryConfirm(data[indextr])")
                      vm-icon(icon="trash-2-outline")
                      slot &nbsp;{{ $t('strings.delete') }}
                    vm-dropdown-item.d-flex.justify-content-between(v-if="data[indextr]['status'] == '1'" @click="setActionCategories(data[indextr], 'invoiced')")
                      vm-icon(icon="checkmark-circle-outline")
                      slot &nbsp;{{ $t('strings.action_invoiced') }}
                    vm-dropdown-item.d-flex.justify-content-between(@click="imagesCategory(data[indextr])")
                      vm-icon(icon="image-outline")
                      slot &nbsp;{{ $t('strings.add_images') }}
                    //- More actions
          vm-pagination(:total="pagination.totalPages" v-model="currentPage" goto)
          transition(name="enter")
            .total-records(v-if="total>0") Total: {{ total | currency }}
</template>

<script>
import ModalCategories from '@/components/modals/ModalCategories.vue'
import ModalImport from '@/components/modals/ModalImport.vue'
import ModalImagesCategories from '@/components/modals/ModalImagesCategories.vue'
import parseDeleteMany from '@/utils/parseDeleteMany'
import parseVuexObject from '@/utils/parseVuexObject'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('Categories')

export default {
  name: 'Categories',
  components: {
    ModalCategories,
    ModalImagesCategories,
    ModalImport
  },
  data: () => ({
    currentPage: 1,
    isModalAdd: true,
    newRecord: {},
    selected: [],
    form: {},
    columns: [
      'title',
      'image',
      'about',
      'total_price',
      'discount',
      'color'
    ],
    columnsOrderBy: [
      // Nota solo si las columnas son atributos

    ],
    status: [
      // Agregar los estatus si maneja
      // {
      //   text: 'Pagado',
      //   value: 2,
      //   color: 'warning'
      // }
    ],
    filters: {
      // Nota: Estos campos se parsearan en el v-model de los filtros. Ver linea 60
      where: {
        title: '',
        param: ''
      },
      whereIn: {
        // Agrega las columnas que se filtraran con mas de una opcion ejemplo: status: []
        title: ['title']
      },
      whereBetween: {
        // Agrega las columnas que se filtraran entre paramentros ejemplo: priece: []
      },
      betweenDates: {
        // Agrega las columnas que se filtraran entre fechas: created_at: []
      },
      orderBy: ''
    },
    filtersClear: {}
  }),
  async created () {
    this.filtersClear = parseVuexObject(this.filters)
    await this.getCategories(1)
    // await this.getCategoriesCatalog()
  },
  methods: {
    ...mapActions([
      'deleteCategory',
      'deleteCategories',
      'loadCategories',
      'loadCatalog',
      'getCategoriesCatalog',
      'actionCategories',
      'setModalImportVisible',
      'setModalImagesVisible',
      'setModalVisible',
      'printReport',
      'applyFilter',
      'clearFilter'
    ]),
    imagesCategory (category, index) {
      this.isModalAdd = true
      this.setModalImagesVisible(true)
      this.form = { ...category }
    },
    colorStatus (code) {
      return this.status.find(e => e.value === parseInt(code))['color']
    },
    setFocusSearch () {
      this.$refs.search.$refs.vminput.focus()
    },
    editShortcut () {
      if (this.selected.length === 0 || this.selected.length > 1) return
      const idx = this.categories.findIndex(u => u.id === this.selected[0].id)
      this.editCategories(this.selected[0], idx)
    },
    addCategories () {
      this.isModalAdd = true
      this.setModalVisible(true)
      this.newRecord = {
        color: '#3498db'
      }
    },
    editCategories (categories, index) {
      this.isModalAdd = false
      this.setModalVisible(true)
      this.newRecord = { ...categories }
    },
    async deleteCategoryConfirm (categories) {
      let t = this
      this.auxDeleteCategories = () => {
        t.deleteCategory(categories).then(() => { t.selected = [] })
      }
      this.$vm.dialog({
        color: 'danger',
        title: this.$t('front.delete_modal'),
        text: this.$t('front.delete_confirmation', { model: this.$t('strings.categories'), attribute: this.$t(categories.layer_id) }),
        accept: this.auxDeleteCategories
      })
    },
    async deleteCategoriesConfirm () {
      let t = this
      let categoriesMany = parseDeleteMany(this.selected, 'layer_id')
      this.auxDeleteCategories = () => {
        t.deleteCategories(categoriesMany).then(() => { t.selected = [] })
      }
      this.$vm.dialog({
        color: 'danger',
        title: this.$t('front.delete_modal'),
        text: this.$t('front.delete_confirmation', { model: this.$t('strings.categories'), attribute: categoriesMany.values }),
        accept: this.auxDeleteCategories
      })
    },
    async setActionCategories (record, action) {
      record.id && this.actionCategories({ id: record.id, action })
    },
    async getCategories (page) {
      let t = this
      this.loadCategories({ page }).then(data => t.getProps(t.$route.params.id))
    },
    getProps (index) {
      let categories = this.categories.filter(categories => categories.id === parseInt(index))[0]
      categories && this.editCategories(categories, index)
    },
    autoCompleteFunc (value, url) {
      this.loadCatalog({ filter: value, url: url })
    },
    newObjectFuncModal (value) {
      //
    },
    newObjectFuncView (value) {
      //
    },
    handleChange (date) {
      // this.filters.betweenDates.created_at = date
    },
    hiddeDrop () {
      let [dropdownMenu] = this.$refs.dropdown.$children.filter((item) => {
        return item.hasOwnProperty('dropdownVisible')
      })
      dropdownMenu.dropdownVisible = false
    }
  },
  computed: {
    ...mapGetters([
      'categories',
      'pagination',
      'filterParams'
    ]),
    searchPlaceholder () {
      let t = this
      let concatColumns = Object.keys(this.filters.where).reduce((str, column, index) => {
        if (column !== 'param' && index < Object.keys(t.filters.where).length - 2) return (index > 0) ? `${str}, $\{t.$t('categories.' + column)}` : `${str} ${t.$t('categories.' + column)}`
        return str
      }, '')
      return this.$t('strings.search', { attribute: this.$t('strings.categories'), columns: concatColumns, column: this.$t('categories.' + Object.keys(this.filters.where)[Object.keys(t.filters.where).length - 2]) })
    },
    enabledDelete () {
      return this.selected.length > 0
    },
    total () {
      return this.selected.reduce((prev, cur) => prev + parseFloat(cur.total), 0).toFixed(2)
    }
  },
  watch: {
    currentPage (currentPage) {
      this.getCategories(currentPage)
    },
    filterParams (filter) {
      this.hiddeDrop()
      filter.length === 0 && (this.filters = parseVuexObject(this.filtersClear))
      this.selected = []
      this.currentPage = 1
      this.getCategories(this.currentPage)
    }
  }
}
</script>

<style lang="scss">
.filters {
  .filter {
    padding: 5px 10px;
    width: 250px;
  }
}
.con-vm-tooltip {
  display: inline-block;
  position: relative;
}
.color-circle {
  border-radius: 50%;
  height: 20px;
  width: 20px;
  position:relative;
  &:after {
    border-radius: 50%;
    content: '';
    position: absolute;
    top: -5px;
    left: -5px;
    right: -5px;
    bottom: -5px;
    border: rgb(230, 230, 230) 2px solid;
  }
}
.vm-table--header {
  padding: 10px;
  span:nth-child(1)  {
    width: 100%;
  }
  .input-select-con{
    span {
      width: auto !important;
    }
  }
  .justify-content-between {
    div:last-child {
      .vm-button {
        margin: 0 3px;
      }
      .vm-con-dropdown {
        float: left;
      }
      .con-select {
        display: inline-block;
        input {
          height: 32px;
        }
      }
    }
  }
}
</style>
